import { buttonTypes, type InitData, type models } from '../models';
import { logger } from '../logger';

export abstract class Modal {
  protected modalDiv: HTMLDivElement | null;
  protected buttonsAsLinks: boolean = true;
  protected initData: InitData = null;
  private _buttons: Map<HTMLButtonElement, () => void>;
  private _opened: boolean = true;
  private _automaticClose: boolean = false;
  private _showCloseButton: boolean = true;

  protected readonly closeSvgIconBig: string = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M11.6573 9.99198L18.3177 16.6524L16.6526 18.3175L9.99223 11.6571L3.33184 18.3332L1.66675 16.6681L8.32713 10.0077L1.66675 3.3316L3.33184 1.6665L9.99223 8.32689L16.6683 1.6665L18.3334 3.3316L11.673 9.99198H11.6573Z" fill="#7F7F7F"/>
    </svg>`;

  protected readonly closeSvgIconSmall: string = `
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M9.00121 16.4998C7.14286 16.4989 5.35109 15.8077 3.97365 14.5602C2.5962 13.3128 1.73132 11.5981 1.54682 9.74892C1.36231 7.89975 1.87134 6.04798 2.97515 4.55296C4.07896 3.05794 5.69882 2.02631 7.52036 1.65825C9.3419 1.2902 11.2352 1.61197 12.8329 2.56114C14.4306 3.5103 15.6187 5.01916 16.1666 6.7949C16.7145 8.57063 16.5832 10.4866 15.7982 12.171C15.0131 13.8554 13.6303 15.1881 11.9181 15.9104C10.9949 16.2997 10.0031 16.5001 9.00121 16.4998ZM6.1312 5.28103L5.25621 6.15603L8.12495 8.99853L5.28497 11.8698L6.15997 12.7448L9.00497 9.86979L11.8725 12.7129L12.7518 11.8335L9.8837 8.99167L12.7231 6.12355L11.8387 5.24853L8.99997 8.11604L6.1312 5.28103Z" fill="#666666"/>
  </svg>`;

  protected readonly alertSvgIcon: string = `
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.0001 2.66699C8.58675 2.66699 2.66675 8.58699 2.66675 16.0003C2.66675 23.4137 8.58675 29.3337 16.0001 29.3337C23.4134 29.3337 29.3334 23.4137 29.3334 16.0003C29.3334 8.58699 23.4134 2.66699 16.0001 2.66699ZM18.7067 21.5737C18.1334 21.8003 17.6801 21.9737 17.3334 22.0803C16.9867 22.2003 16.6001 22.267 16.1467 22.267C15.4534 22.267 14.9067 22.0937 14.5201 21.7603C14.1334 21.4137 13.9467 20.987 13.9467 20.467C13.9467 20.267 13.9601 20.0537 13.9867 19.8537C14.0134 19.6403 14.0667 19.4003 14.1201 19.1337L14.8267 16.6003C14.8934 16.3603 14.9467 16.1337 14.9867 15.9203C15.0267 15.707 15.0534 15.507 15.0534 15.3203C15.0534 15.0003 14.9867 14.7737 14.8534 14.6403C14.7201 14.507 14.4667 14.4537 14.0934 14.4537C13.9067 14.4537 13.7201 14.4803 13.5201 14.547C13.3334 14.6003 13.1601 14.6537 13.0267 14.707L13.2134 13.9203C13.6801 13.7337 14.1334 13.5737 14.5601 13.4403C14.9867 13.307 15.3867 13.227 15.7734 13.227C16.4667 13.227 16.9867 13.4003 17.3601 13.7337C17.7334 14.067 17.9201 14.4937 17.9201 15.027C17.9201 15.1337 17.9067 15.3337 17.8801 15.6137C17.8534 15.8937 17.8134 16.147 17.7467 16.3737L17.0401 18.8937C16.9867 19.0937 16.9334 19.3337 16.8801 19.587C16.8401 19.8537 16.8134 20.0403 16.8134 20.1737C16.8134 20.507 16.8934 20.7337 17.0401 20.8537C17.1867 20.9737 17.4534 21.0403 17.8267 21.0403C18.0001 21.0403 18.2001 21.0137 18.4134 20.947C18.6267 20.8803 18.7867 20.827 18.8934 20.787L18.7067 21.5737ZM18.5734 11.3203C18.2401 11.627 17.8401 11.787 17.3734 11.787C16.9067 11.787 16.5067 11.6403 16.1601 11.3203C15.8267 11.0137 15.6534 10.627 15.6534 10.187C15.6534 9.74699 15.8267 9.37366 16.1601 9.05366C16.4934 8.74699 16.8934 8.58699 17.3734 8.58699C17.8534 8.58699 18.2401 8.74699 18.5734 9.05366C18.9067 9.36033 19.0801 9.74699 19.0801 10.187C19.0801 10.627 18.9067 11.0003 18.5734 11.3203Z" fill="#51BBFF"/>
    </svg>`;

  constructor(message: models.RewardMessage, initData: InitData = null) {
    // todo - set buttonsAsLinks based on version
    this.initData = initData;
    this.modalDiv = null;
    this._buttons = new Map<HTMLButtonElement, () => void>();
    this.openModal(message);
  }

  /**
   * render rewardMessage
   */
  protected abstract render(rewardMessage: models.RewardMessage): void;

  /**
   * handle button click
   */
  public handleClick(
    buttonTypeNumber: models.ButttonType | undefined,
    parameters: models.RewardButtonParameters | undefined
  ) {
    logger.log('Button clicked with parameters: ', parameters);
    const buttonType: models.ButttonTypeStr = !!buttonTypeNumber
      ? buttonTypes[buttonTypeNumber]
      : 'ButtonToClose';
    switch (buttonType) {
      case 'ButtonToClose':
        this.closeModal();
        break;
      case 'ButtonWithLink': {
        if (!!parameters?.LinkUrl) {
          window.open(parameters?.LinkUrl, '_blank', 'noopener,noreferrer');
        } else {
          this.closeModal();
        }
        break;
      }
      case 'ButtonToGame': {
        const gameIDUrl: string | undefined = this.generateGameUrl(
          parameters?.GameID,
          parameters?.GameSystemName
        );
        if (!!gameIDUrl) {
          window.postMessage({
            type: 'redirect_to_url',
            destination: gameIDUrl
          });
        } else {
          this.closeModal();
        }
        break;
      }
    }
  }

  /**
   * generate game url
   */
  public generateGameUrl(
    gameId: number | undefined,
    systemName: string | undefined
  ): string {
    const platform = new URLSearchParams(window.location.search).get(
      'platform'
    );

    let gameUrl = '';

    switch (platform) {
      case 'mobile':
        gameUrl = import.meta.env.VITE_GAME_URL_MOBILE;
        break;
      case 'mobile_ios':
        gameUrl = import.meta.env.VITE_GAME_URL_MOBILE_IOS;
        break;
      case 'mobile_android':
        gameUrl = import.meta.env.VITE_GAME_URL_MOBILE_ANDROID;
        break;
      case 'web':
        gameUrl = import.meta.env.VITE_GAME_URL_WEB;
        break;
    }

    gameUrl = gameUrl
      .replace('{{game_id}}', gameId ? gameId.toString() : '')
      .replace('{{system_name}}', systemName ? systemName : '');
    logger.log('Generated game URL: ', gameUrl);
    return gameUrl;
  }

  /**
   * add button
   */
  public addButton(button: HTMLButtonElement, wraper: () => void = () => {}) {
    this._buttons.set(button, wraper);
  }

  /**
   * return is opened
   */
  public isOpened(): boolean {
    return this._opened;
  }

  /**
   * return is automatic close
   */
  public automaticClose(): boolean {
    return this._automaticClose;
  }

  /**
   * return is automatic close
   */
  public showCloseButton(): boolean {
    return this._showCloseButton;
  }

  /**
   * open modal
   */
  public openModal(message: models.RewardMessage) {
    this._automaticClose = !!message.MessageDelay;

    if (!!message.MessageDelay && !!message.MessageDelayUnitID) {
      this.closeModalAfterDelay(
        message.MessageDelay,
        message.MessageDelayUnitID
      );
    }

    if (!!message.RewardButtons) {
      this._showCloseButton = message.RewardButtons.some(
        button => button.Type === 1 // close button
      );

      if (message.Variant !== 5) {
        // alert
        message.RewardButtons = message.RewardButtons.filter(
          button => button.Type !== 1 // close button
        );
      }
    }

    this._opened = true;
    this.render(message);
    logger.log('Modal opened with message: ', message);
  }

  /**
   * close modal
   */
  public closeModal() {
    this._opened = false;
    this.modalDiv?.remove();
    this.modalDiv = null;
    this._buttons.forEach((wraper, button) =>
      button.removeEventListener('click', wraper)
    );

    // remove all empty wrapers for animations
    document.querySelectorAll('div.toast-container-wrapper').forEach(el => {
      if (!el.querySelector(':scope > div')) {
        el.remove();
      }
    });

    logger.log('Modal closed after click. ');
  }

  /**
   * close modal after delay
   */
  public closeModalAfterDelay(delay: number, unit: models.MessageDelayUnitID) {
    setTimeout(
      () => {
        this.closeModal();
        logger.log('Modal closed after delay: ', delay, ' unit: ', unit);
      },
      delay * (unit === 1 ? 1000 : 60000)
    ); // seconds or minutes
  }

  /**
   * add href to link that is as button
   */
  protected _addHrefToLink(
    rewardButton: models.RewarButton,
    btn: HTMLAnchorElement
  ) {
    const buttonType: models.ButttonTypeStr = !!rewardButton.Type
      ? buttonTypes[rewardButton.Type]
      : 'ButtonToClose';
    switch (buttonType) {
      case 'ButtonToClose':
        btn.href = '#';
        break;
      case 'ButtonWithLink': {
        btn.href = rewardButton.Parameters?.LinkUrl as string;
        btn.target = '_blank';
        btn.rel = 'noopener noreferrer';
        break;
      }
      case 'ButtonToGame': {
        const gameIDUrl: string | undefined = this.generateGameUrl(
          rewardButton.Parameters?.GameID,
          rewardButton.Parameters?.GameSystemName
        );
        btn.href = gameIDUrl;
        btn.target = '_top';
        break;
      }
    }
  }
}
